var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2.6984V8.4C12.8 8.93043 12.5893 9.43914 12.2142 9.81421C11.8391 10.1893 11.3304 10.4 10.8 10.4H2C1.46957 10.4 0.960859 10.1893 0.585786 9.81421C0.210714 9.43914 0 8.93043 0 8.4V2.6984L6.1968 6.3448C6.25836 6.38111 6.32853 6.40026 6.4 6.40026C6.47147 6.40026 6.54164 6.38111 6.6032 6.3448L12.8 2.6984ZM10.8 2.47621e-08C11.2921 -7.73728e-05 11.767 0.181285 12.1338 0.509392C12.5005 0.837498 12.7335 1.28931 12.788 1.7784L6.4 5.536L0.0120001 1.7784C0.0665266 1.28931 0.299459 0.837498 0.666236 0.509392C1.03301 0.181285 1.50788 -7.73728e-05 2 2.47621e-08H10.8Z",
    fill: "#545454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.058bb188a64a9c1b4494d2ea422c064d.svg";
export { ForwardRef as ReactComponent };